import { useSiteContext, useTranslation } from '@eti/providers';
import { Heading, Inline, Stack, Text, textVariants } from '@etg/wings';
import { css } from '@eti/styles';
import { MEAL, SEAT_MAP } from '@eti/products/dist/products';
import { constants } from '@eti/utils';
import TitledCard from '../../../../../common/components/TitledCard';
import type { BoundBaggageInfoType } from '../baggages/models';
import { useOrderDetails } from '../../../containers/OrderDetailsContext';
import PassengerCard from './PassengerCard';

const contactDetailsStackStyles = css`
  padding-top: 24px;
`;

interface PassengersProps {
  baggagePerBound: BoundBaggageInfoType[];
}

const Passengers = ({ baggagePerBound }: PassengersProps) => {
  const { t } = useTranslation();
  const { agencyAccount } = useSiteContext();
  const { customerDetails, extraProducts, travelers } = useOrderDetails();

  const seat = extraProducts?.find(
    (boughtProduct) => Number(boughtProduct?.id) === Number(SEAT_MAP.id),
  );

  const meal = extraProducts?.find(
    (boughtProduct) => Number(boughtProduct?.id) === Number(MEAL.id),
  );

  return (
    <TitledCard
      data-testid="passengers-section"
      title={t('OrderDetails.Passenger.Overview.Header')}
    >
      <Stack>
        <Text>{t('OrderDetails.Passenger.Overview.Description')}</Text>
        <Stack role="list">
          {travelers.map((traveler, travelerIndex) => (
            <div key={`traveller-${traveler.name}`} role="listitem">
              <PassengerCard
                baggagePerBound={baggagePerBound}
                meal={meal}
                passenger={traveler}
                passengerIndex={travelerIndex}
                seat={seat}
              />
            </div>
          ))}
        </Stack>
      </Stack>
      {!agencyAccount && (
        <Stack className={contactDetailsStackStyles} data-testid="customer-details" spacing={8}>
          <Heading level={3}>{t('OrderDetails.ContactDetails.Title')}</Heading>
          <Stack spacing={4}>
            <Inline spacing={8}>
              <Text variant={textVariants._14_BOLD}>
                {t('OrderDetails.Baggage.CustomerInformation.Email.Label')}
              </Text>
              <span className={constants.MOUSE_FLOW_CLASS_NAMES}>{customerDetails?.email}</span>
            </Inline>
            <Inline spacing={8}>
              <Text variant={textVariants._14_BOLD}>
                {t('OrderDetails.Baggage.CustomerInformation.PhoneNumber.Label')}
              </Text>
              <Text className={constants.MOUSE_FLOW_CLASS_NAMES}>{customerDetails?.phone}</Text>
            </Inline>
          </Stack>
        </Stack>
      )}
    </TitledCard>
  );
};

export default Passengers;
